import React from 'react';

export default function DevTab({
  onTestLlm,
  testLlmStatus = { phase: 'idle', result: '' },
  onTestDam,
  testDamStatus = { phase: 'idle', result: '' },
  onTestLogoUpload,
  testLogoStatus = { phase: 'idle', result: '' },
  onTestLogoMatch,
  testLogoMatchStatus = { phase: 'idle', result: '' },
  onDumpPage,
  onDumpAll,
  onDumpComponents,
  pageDump = { phase: 'idle', json: '' },
  onListPages,
  sitePages = { phase: 'idle', result: '' },
  onReplacePageJcr,
  replaceJcrStatus = { phase: 'idle', result: '' },
}) {
  return (
    <div className="dp-tab-content dp-dev-tab">
      <button
        className={`dp-btn dp-btn-full dp-btn-test-llm ${testLlmStatus.phase === 'ok' ? 'is-ok' : ''} ${testLlmStatus.phase === 'error' ? 'is-error' : ''}`}
        onClick={testLlmStatus.phase !== 'testing' ? onTestLlm : undefined}
        disabled={testLlmStatus.phase === 'testing'}
      >
        {testLlmStatus.phase === 'testing' && <span className="dp-spinner" aria-hidden />}
        <span>
          {testLlmStatus.phase === 'testing' ? 'Testing LLM…' :
           testLlmStatus.phase === 'ok' ? 'LLM OK' :
           testLlmStatus.phase === 'error' ? 'LLM Error' :
           'Test LLM API'}
        </span>
      </button>
      {testLlmStatus.result && (
        <div className={`dp-status ${testLlmStatus.phase === 'error' ? 'is-error' : 'is-ok'}`}>
          <span>{testLlmStatus.result}</span>
        </div>
      )}

      <button
        className={`dp-btn dp-btn-full dp-btn-test-llm ${testDamStatus.phase === 'ok' ? 'is-ok' : ''} ${testDamStatus.phase === 'error' ? 'is-error' : ''}`}
        onClick={testDamStatus.phase !== 'testing' ? onTestDam : undefined}
        disabled={testDamStatus.phase === 'testing'}
      >
        {testDamStatus.phase === 'testing' && <span className="dp-spinner" aria-hidden />}
        <span>
          {testDamStatus.phase === 'testing' ? 'Listing DAM…' :
           testDamStatus.phase === 'ok' ? 'DAM OK' :
           testDamStatus.phase === 'error' ? 'DAM Error' :
           'Test DAM Assets'}
        </span>
      </button>
      {testDamStatus.result && (
        <div className={`dp-status ${testDamStatus.phase === 'error' ? 'is-error' : 'is-ok'}`}>
          <span style={{ whiteSpace: 'pre-wrap', fontSize: '11px' }}>{testDamStatus.result}</span>
        </div>
      )}

      <button
        className={`dp-btn dp-btn-full dp-btn-test-llm ${testLogoStatus.phase === 'ok' ? 'is-ok' : ''} ${testLogoStatus.phase === 'error' ? 'is-error' : ''}`}
        onClick={testLogoStatus.phase !== 'uploading' ? onTestLogoUpload : undefined}
        disabled={testLogoStatus.phase === 'uploading'}
      >
        {testLogoStatus.phase === 'uploading' && <span className="dp-spinner" aria-hidden />}
        <span>
          {testLogoStatus.phase === 'uploading' ? 'Uploading LOGO…' :
           testLogoStatus.phase === 'ok' ? 'Logo Upload OK' :
           testLogoStatus.phase === 'error' ? 'Logo Upload Error' :
           'Upload Test Logo (IKEA)'}
        </span>
      </button>
      {testLogoStatus.result && (
        <div className={`dp-status ${testLogoStatus.phase === 'error' ? 'is-error' : 'is-ok'}`}>
          <span style={{ whiteSpace: 'pre-wrap', fontSize: '11px' }}>{testLogoStatus.result}</span>
        </div>
      )}

      <button
        className={`dp-btn dp-btn-full dp-btn-test-llm ${testLogoMatchStatus.phase === 'ok' ? 'is-ok' : ''} ${testLogoMatchStatus.phase === 'error' ? 'is-error' : ''}`}
        onClick={testLogoMatchStatus.phase !== 'testing' ? onTestLogoMatch : undefined}
        disabled={testLogoMatchStatus.phase === 'testing'}
      >
        {testLogoMatchStatus.phase === 'testing' && <span className="dp-spinner" aria-hidden />}
        <span>
          {testLogoMatchStatus.phase === 'testing' ? 'Checking…' :
           testLogoMatchStatus.phase === 'ok' ? 'Logo Match OK' :
           testLogoMatchStatus.phase === 'error' ? 'Logo Match Error' :
           'Test Logo Pre-Assignment'}
        </span>
      </button>
      {testLogoMatchStatus.result && (
        <div className={`dp-status ${testLogoMatchStatus.phase === 'error' ? 'is-error' : 'is-ok'}`}>
          <span style={{ whiteSpace: 'pre-wrap', fontSize: '11px' }}>{testLogoMatchStatus.result}</span>
        </div>
      )}

      <button
        className={`dp-btn dp-btn-full dp-btn-test-llm ${sitePages.phase === 'ok' ? 'is-ok' : ''} ${sitePages.phase === 'error' ? 'is-error' : ''}`}
        onClick={sitePages.phase !== 'loading' ? onListPages : undefined}
        disabled={sitePages.phase === 'loading'}
      >
        {sitePages.phase === 'loading' && <span className="dp-spinner" aria-hidden />}
        <span>
          {sitePages.phase === 'loading' ? 'Loading pages…' :
           sitePages.phase === 'ok' ? 'Pages Listed' :
           sitePages.phase === 'error' ? 'Pages Error' :
           'List Site Pages'}
        </span>
      </button>
      {sitePages.result && (
        <div className={`dp-status ${sitePages.phase === 'error' ? 'is-error' : 'is-ok'}`}>
          <span style={{ whiteSpace: 'pre-wrap', fontSize: '11px' }}>{sitePages.result}</span>
        </div>
      )}

      <button
        className={`dp-btn dp-btn-full dp-btn-test-llm ${replaceJcrStatus.phase === 'ok' ? 'is-ok' : ''} ${replaceJcrStatus.phase === 'error' ? 'is-error' : ''}`}
        onClick={replaceJcrStatus.phase !== 'running' ? onReplacePageJcr : undefined}
        disabled={replaceJcrStatus.phase === 'running'}
      >
        {replaceJcrStatus.phase === 'running' && <span className="dp-spinner" aria-hidden />}
        <span>
          {replaceJcrStatus.phase === 'running' ? 'Replacing via JCR…' :
           replaceJcrStatus.phase === 'ok' ? 'JCR Replace OK' :
           replaceJcrStatus.phase === 'error' ? 'JCR Replace Error' :
           'Replace Page (JCR)'}
        </span>
      </button>
      {replaceJcrStatus.result && (
        <div className={`dp-status ${replaceJcrStatus.phase === 'error' ? 'is-error' : 'is-ok'}`}>
          <span style={{ whiteSpace: 'pre-wrap', fontSize: '11px' }}>{replaceJcrStatus.result}</span>
        </div>
      )}

      <div className="dp-btn-row">
        <button
          className={`dp-btn dp-btn-third dp-btn-dump ${pageDump.phase === 'done' ? 'is-done' : ''} ${pageDump.phase === 'error' ? 'is-error' : ''}`}
          onClick={pageDump.phase !== 'collecting' ? onDumpPage : undefined}
          disabled={pageDump.phase === 'collecting'}
        >
          {pageDump.phase === 'collecting' && <span className="dp-spinner" aria-hidden />}
          <span>{pageDump.phase === 'collecting' ? '…' : 'Texts'}</span>
        </button>
        <button
          className={`dp-btn dp-btn-third dp-btn-dump ${pageDump.phase === 'done' ? 'is-done' : ''} ${pageDump.phase === 'error' ? 'is-error' : ''}`}
          onClick={pageDump.phase !== 'collecting' ? onDumpComponents : undefined}
          disabled={pageDump.phase === 'collecting'}
        >
          <span>Components</span>
        </button>
        <button
          className={`dp-btn dp-btn-third dp-btn-dump ${pageDump.phase === 'done' ? 'is-done' : ''} ${pageDump.phase === 'error' ? 'is-error' : ''}`}
          onClick={pageDump.phase !== 'collecting' ? onDumpAll : undefined}
          disabled={pageDump.phase === 'collecting'}
        >
          <span>All</span>
        </button>
      </div>
      {pageDump.phase === 'done' && pageDump.json && (
        <div className="dp-dump-area">
          <div className="dp-dump-toolbar">
            <span className="dp-dump-label">
              {Math.round(pageDump.json.length / 1024)} KB
            </span>
            <button
              type="button"
              className="dp-btn dp-btn-small"
              onClick={() => {
                navigator.clipboard.writeText(pageDump.json).catch(() => {});
              }}
            >
              Copy JSON
            </button>
          </div>
          <textarea
            className="dp-dump-json"
            readOnly
            value={pageDump.json}
            rows={12}
            onFocus={(e) => e.target.select()}
          />
        </div>
      )}
      {pageDump.phase === 'error' && (
        <div className="dp-status is-error">
          <span>{pageDump.json}</span>
        </div>
      )}

    </div>
  );
}
